import file from '../common/file';
import folder from '../common/folder';

interface additionalParams {
  includeTargetName?: boolean;
}

function isFolder(obj: any): obj is folder {
  return typeof obj.title === 'string';
}

const buildFilePath = (
  target: file | folder,
  folders: folder[],
  additionalParams?: additionalParams
): string => {
  // Find the folder hierarchy for the file
  const folderHierarchy: folder[] = [];
  let currentFolder = folders.find(
    (folder) =>
      folder.folder_uid ===
      (isFolder(target) ? target.parent_folder : target.folder_uid)
  );
  while (currentFolder) {
    folderHierarchy.unshift(currentFolder); // Add the current folder to the beginning of the hierarchy
    currentFolder = folders.find(
      (folder) => folder.folder_uid === currentFolder?.parent_folder
    );
  }

  // Build the path
  let path = '';
  folderHierarchy.forEach((folder) => {
    path += `${folder.title}/`;
  });

  if (additionalParams && additionalParams.includeTargetName) {
    path += `${isFolder(target) ? target.title : target.filename}`;
  } else {
    path = path.substring(0, path.length - 1); // removes the "/" at the end of the string
  }

  return path;
};

export default buildFilePath;
